import { Component, inject } from '@angular/core';
import { LevelPerProcessService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LevelPerProcessCreateDto,
  LevelPerProcessDto,
  LevelPerProcessExcelDownloadDto,
  LevelPerProcessUpdateDto,
} from '../proxy/controlling/dtos/level-per-process';
import { LEVELPERPROCESS_CONFIG, LEVELPERPROCESS_FIELDS } from './level-per-process.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-level-per-process',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LevelPerProcessService, ConfirmationService],
  templateUrl: './level-per-process.html',
  styleUrl: './level-per-process.scss',
})
export class LevelPerProcess extends BaseCrudComponent<
  LevelPerProcessDto,
  LevelPerProcessCreateDto,
  LevelPerProcessUpdateDto,
  LevelPerProcessExcelDownloadDto
> {
  service = inject(LevelPerProcessService);
  config = LEVELPERPROCESS_CONFIG;
  fields = LEVELPERPROCESS_FIELDS;

  protected prepareUpdateDto(data: any, selected: LevelPerProcessDto): LevelPerProcessUpdateDto {
    return {
      levelId: data.levelId,
      processId: data.processId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LevelPerProcess';
  }
}
